import { WeeklyGitCommitDigestArticle } from '@/components/weekly-git-commit-digest/weekly-git-commit-digest-article'
import { Container } from '@/components/container'
import { Footer } from '@/components/footer'
import { Navbar } from '@/components/navbar'
import { Head } from '@inertiajs/react'

const TITLE = 'AI Weekly Git Commit Digest for Stakeholders'
const DESCRIPTION =
  'An AI weekly git commit digest is a business progress summary of GitHub commits for non-technical stakeholders, sent to Slack and email.'

type Faq = {
  question: string
  answer: string
}

type Props = {
  headline: string
  faqs: Faq[]
}

export default function WeeklyGitCommitDigestShow({ headline, faqs }: Props) {
  return (
    <>
      <Head title={TITLE}>
        <meta head-key="description" name="description" content={DESCRIPTION} />
      </Head>
      <div className="flex min-h-screen flex-col">
        <main className="flex-1 overflow-hidden">
          <Container>
            <Navbar />
          </Container>
          <div className="from-background via-feature-subtle/50 to-muted/20 min-h-100vh bg-gradient-to-b">
            <Container className="py-16 md:py-24">
              <WeeklyGitCommitDigestArticle headline={headline} faqs={faqs} />
            </Container>
          </div>
        </main>
        <Footer />
      </div>
    </>
  )
}
